import { createActionCreator, createReducer } from 'deox';
import { createSelector } from 'reselect';
import { AppState } from 'types/AppState';
import { User } from 'types/User';
import { UserModel } from '@picsart/rc/types/models/user';

export const setUser = createActionCreator('USER/SET', resolve => (payload: UserModel) =>
  resolve(payload)
);

export const setStoreUser = createActionCreator('USER/SET_STORE', resolve => (payload: UserModel) =>
  resolve(payload)
);

export const updateUser = createActionCreator('USER/UPDATE', resolve => (payload: Partial<User>) =>
  resolve(payload)
);

export const user = createReducer(null, handle => [
  handle(setStoreUser, (_, { payload }) => ({
    ...payload
  })),
  handle(updateUser, (state, { payload }) => ({ ...state, ...payload }))
]);

export const getUser = (state: AppState): User | null => state.user;
export const getUserKey = (state: AppState): string | null => getUser(state)?.key;
export const isSubscribed = createSelector<AppState, User, boolean>(getUser, usr => {
  return !!(usr?.subscribed || usr?.subscription?.granted) ?? false;
});
